import { AlgoanLogo } from '../icons';
import styled from 'styled-components';

export type DashboardLogoSize = 'small' | 'medium' | 'big';

export interface DashboardLogoProps {
  size?: DashboardLogoSize;
}

export const DashboardLogo: React.FC<DashboardLogoProps> = ({ size = 'medium' }) => {
  return (
    <S.Container>
      <>
        <S.Dashboard size={size}>Dashboard</S.Dashboard>
        <S.Signature size={size}>
          <S.By size={size}>by</S.By>
          <S.AlgoanLogo size={size} />
        </S.Signature>
      </>
    </S.Container>
  );
};

const S = {
  Container: styled.div`
    float: right;
    flex: 1;
  `,
  Dashboard: styled.div<{ size: DashboardLogoSize }>`
    font-weight: bold;

    ${({ size }) => {
      switch (size) {
        case 'small':
          return ` 
          font-size: 15px;
          line-height: 19px;
          margin-top: 8px;
          `;
        case 'big':
          return `
          line-height: 53px;
          font-size: 42px;
          `;
        default:
          return `
        font-size: 22px;
        line-height: 28px;
        `;
      }
    }}
    color: ${({ theme }) => theme.algoanBlue};
  `,
  Signature: styled.div<{ size: DashboardLogoSize }>`
    margin-right: ${(props) => (props.size === 'big' ? '3px' : '0px')};
    margin-top: ${(props) => (props.size === 'big' ? '0px' : '-3px')};
    display: flex;
    float: right;
    color: ${(props) => props.theme.algoanBlue};
    line-height: 14px;
    font-size: 9px;
  `,
  AlgoanLogo: styled(AlgoanLogo)<{ size: DashboardLogoSize }>`
    ${({ size }) =>
      size === 'big'
        ? `
         height: 24px;
         width: 73.45px;
         float: right; `
        : `
        margin-top: 2px;
        margin-left: 3px;
        width: 36.72px;
        height: 12px;
    `}
  `,
  By: styled.div<{ size: DashboardLogoSize }>`
    ${({ size }) =>
      size === 'big'
        ? `
        margin-top: 3px;
        width: 18px;
        height: 20px;
        font-size: 16px;
        margin-right: 5px;
       `
        : `
        font-size: 9px;
        margin-right: 5px;
        display: inline-block;
        width: 18px;
        height: 20px;
        margin-right: -8px;
    `};
  `,
};
